import { render, staticRenderFns } from "./LoyaltyNotifyList.vue?vue&type=template&id=3b6f4e46&"
import script from "./LoyaltyNotifyList.vue?vue&type=script&lang=js&"
export * from "./LoyaltyNotifyList.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyNotifyList.vue?vue&type=style&index=0&id=3b6f4e46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports